// extracted by mini-css-extract-plugin
export default {"emptyState":"emptyStatefMJHh","invoiceCardContainer":"invoiceCardContainerWLh9B"};